export const FILE_UPLOAD_MAX_SIZE = 25600000;

export const SYNCFUSION_UPLOAD_SUCCESS_STATUS_CODE = '2';
